// المسار: src/AdminPanel.js
import React, { useState } from 'react';

const AdminPanel = ({ 
  orders, onAddOrder, onUpdateStatus, 
  products, onAddProduct, onDeleteProduct, 
  reviews, onAddReview, onDeleteReview,
  onChangePassword 
}) => {
  const [activeTab, setActiveTab] = useState('maintenance'); 

  // الإحصائيات مع حماية ضد الأخطاء
  const stats = {
    totalOrders: orders ? orders.length : 0,
    pending: orders ? orders.filter(o => o.status === 'قيد الانتظار').length : 0,
    completed: orders ? orders.filter(o => o.status === 'جاهز للاستلام').length : 0,
    revenue: orders ? orders.reduce((acc, o) => acc + (parseInt(o.cost.toString().replace(/\D/g, '')) || 0), 0) : 0
  };

  const [newClient, setNewClient] = useState({ clientName: '', device: '', problem: '', cost: '' });
  const [newProduct, setNewProduct] = useState({ name: '', price: '', image: '', category: 'عام' });
  const [newReview, setNewReview] = useState({ name: '', comment: '', rating: 5 });
  const [passData, setPassData] = useState({ newPass: '' });

  // دوال العمليات
  const handleOrderSubmit = (e) => {
    e.preventDefault();
    if(!newClient.clientName) return alert("اكتب اسم العميل");
    onAddOrder({ id: Math.floor(1000+Math.random()*9000).toString(), ...newClient, status: "قيد الانتظار" });
    setNewClient({ clientName: '', device: '', problem: '', cost: '' });
  };

  const handleProductSubmit = (e) => {
    e.preventDefault();
    if(!newProduct.image) return alert("الرجاء رفع صورة");
    onAddProduct({ ...newProduct, id: Date.now(), price: parseInt(newProduct.price) });
    setNewProduct({ name: '', price: '', image: '', category: 'عام' });
    alert("تم إضافة المنتج ✅");
  };

  const handleReviewSubmit = (e) => { 
    e.preventDefault(); 
    onAddReview({ id: Date.now(), ...newReview }); 
    setNewReview({ name: '', comment: '', rating: 5 }); 
    alert("تم النشر ✅"); 
  };

  const handlePassChange = () => { 
    if(passData.newPass.length < 4) return alert("كلمة السر ضعيفة (يجب أن تكون 4 أرقام/حروف على الأقل)"); 
    onChangePassword(passData.newPass); 
    setPassData({newPass:''}); 
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setNewProduct({ ...newProduct, image: reader.result });
      reader.readAsDataURL(file);
    }
  };

  const printRepairTicket = (order) => {
    const w = window.open('', '', 'width=600,height=600');
    w.document.write(`<html><head><title>Receipt #${order.id}</title><style>body{font-family:monospace;text-align:center;direction:rtl;padding:20px}.box{border:2px dashed #000;padding:20px;max-width:300px;margin:0 auto}h2,p{margin:5px 0}.bar{font-size:20px;letter-spacing:5px;font-weight:bold;margin:15px 0}</style></head><body><div class="box"><h2>CPE Tech</h2><p>وصل استلام صيانة</p><div class="bar">*${order.id}*</div><div style="text-align:right;margin-top:15px"><p><strong>العميل:</strong> ${order.clientName}</p><p><strong>الجهاز:</strong> ${order.device}</p><p><strong>العطل:</strong> ${order.problem}</p><p><strong>السعر:</strong> ${order.cost}</p><p><strong>التاريخ:</strong> ${new Date().toLocaleDateString()}</p></div><hr/><p style="font-size:10px">المحل غير مسؤول بعد 30 يوم</p></div><script>window.print();window.close();</script></body></html>`);
    w.document.close();
  };

  const btnClass = (active) => ({ padding: '10px 20px', border: 'none', borderRadius: '8px', cursor: 'pointer', background: active ? '#1e3a8a' : '#e2e8f0', color: active ? 'white' : '#334155', fontWeight: 'bold' });
  const inputClass = { width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', boxSizing: 'border-box' };
  const statCard = (color) => ({ flex: 1, padding: '20px', borderRadius: '15px', color: 'white', background: color, textAlign: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', minWidth: '150px' });

  return (
    <div style={{ background: 'white', padding: '30px', borderRadius: '20px', maxWidth: '1000px', margin: '0 auto', boxShadow: '0 10px 25px rgba(0,0,0,0.05)' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#1e3a8a' }}>📊 لوحة القيادة</h2>
      
      {/* الإحصائيات */}
      <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '40px' }}>
        <div style={statCard('#3b82f6')}><h3>{stats.totalOrders}</h3><p>الطلبات</p></div>
        <div style={statCard('#ef4444')}><h3>{stats.pending}</h3><p>انتظار</p></div>
        <div style={statCard('#10b981')}><h3>{stats.completed}</h3><p>جاهز</p></div>
        <div style={statCard('#f59e0b')}><h3>{stats.revenue.toLocaleString()} DZD</h3><p>الدخل</p></div>
      </div>

      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '30px', flexWrap: 'wrap' }}>
        <button onClick={()=>setActiveTab('maintenance')} style={btnClass(activeTab==='maintenance')}>🛠️ الصيانة</button>
        <button onClick={()=>setActiveTab('store')} style={btnClass(activeTab==='store')}>🛍️ المتجر</button>
        <button onClick={()=>setActiveTab('reviews')} style={btnClass(activeTab==='reviews')}>⭐ الآراء</button>
        <button onClick={()=>setActiveTab('settings')} style={btnClass(activeTab==='settings')}>🔐 الإعدادات</button>
      </div>

      {activeTab === 'maintenance' && (
        <div className="fade-in">
           <form onSubmit={handleOrderSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', background: '#f8fafc', padding: '20px', borderRadius: '10px', marginBottom: '20px' }}>
             <h3 style={{gridColumn:'span 2', margin:0}}>➕ تسجيل طلب صيانة</h3>
             <input placeholder="العميل" required value={newClient.clientName} onChange={e=>setNewClient({...newClient, clientName:e.target.value})} style={inputClass} />
             <input placeholder="الجهاز" required value={newClient.device} onChange={e=>setNewClient({...newClient, device:e.target.value})} style={inputClass} />
             <input placeholder="العطل" required value={newClient.problem} onChange={e=>setNewClient({...newClient, problem:e.target.value})} style={inputClass} />
             <input placeholder="التكلفة" required value={newClient.cost} onChange={e=>setNewClient({...newClient, cost:e.target.value})} style={inputClass} />
             <button type="submit" style={{...btnClass(true), gridColumn: 'span 2', background: '#2563eb'}}>حفظ الطلب</button>
           </form>
           
           <table style={{width:'100%', borderCollapse:'collapse'}}>
             <thead><tr style={{background:'#334155', color:'white'}}><th style={{padding:'10px'}}>العميل</th><th>الحالة</th><th>إجراء</th></tr></thead>
             <tbody>
               {(orders || []).map(o => (
                 <tr key={o.id} style={{textAlign:'center', borderBottom:'1px solid #eee'}}>
                   <td style={{padding:'10px'}}>{o.clientName} <br/><small style={{color:'#666'}}>{o.device}</small></td>
                   <td>
                     <select value={o.status} onChange={e=>onUpdateStatus(o.id, e.target.value)} style={{border:'none', background:'transparent', fontWeight:'bold', cursor:'pointer'}}>
                       <option value="قيد الانتظار">🔴 انتظار</option><option value="جاري العمل">🟠 جاري</option><option value="جاهز للاستلام">🟢 جاهز</option>
                     </select>
                   </td>
                   <td><button onClick={()=>printRepairTicket(o)} style={{background:'#475569', color:'white', border:'none', padding:'5px', borderRadius:'5px', cursor:'pointer'}}>🖨️ طباعة</button></td>
                 </tr>
               ))}
             </tbody>
           </table>
        </div>
      )}

      {activeTab === 'store' && (
        <div className="fade-in">
           <form onSubmit={handleProductSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', background: '#ecfdf5', padding: '20px', borderRadius: '10px', marginBottom: '20px' }}>
             <h3 style={{gridColumn:'span 2', margin:0}}>➕ إضافة منتج</h3>
             <input placeholder="اسم المنتج" required value={newProduct.name} onChange={e=>setNewProduct({...newProduct, name:e.target.value})} style={inputClass} />
             <input placeholder="السعر" type="number" required value={newProduct.price} onChange={e=>setNewProduct({...newProduct, price:e.target.value})} style={inputClass} />
             <input placeholder="القسم" value={newProduct.category} onChange={e=>setNewProduct({...newProduct, category:e.target.value})} style={inputClass} />
             <div style={{ gridColumn: 'span 2', border: '2px dashed #10b981', padding: '15px', borderRadius: '10px', textAlign: 'center', background: 'white' }}>
               <label style={{cursor:'pointer', color:'#10b981', fontWeight:'bold'}}>📸 رفع صورة<input type="file" accept="image/*" onChange={handleImageUpload} style={{display:'none'}} /></label>
               {newProduct.image && <div style={{marginTop:'10px'}}><img src={newProduct.image} alt="preview" style={{height:'60px', borderRadius:'5px'}} /></div>}
             </div>
             <button type="submit" style={{...btnClass(true), gridColumn: 'span 2', background: '#059669'}}>نشر</button>
           </form>
           <div style={{display:'flex', gap:'10px', overflowX:'auto'}}>
             {(products || []).map(p => (
               <div key={p.id} style={{minWidth:'140px', border:'1px solid #eee', padding:'10px', borderRadius:'10px', textAlign:'center'}}>
                 {p.image.startsWith('data:') ? <img src={p.image} alt="" style={{width:'100%', height:'80px', objectFit:'cover', borderRadius:'8px'}} /> : <span style={{fontSize:'40px'}}>{p.image}</span>}
                 <div style={{fontWeight:'bold', marginTop:'5px'}}>{p.name}</div>
                 <div style={{color:'green'}}>{p.price} DZD</div>
                 <button onClick={()=>onDeleteProduct(p.id)} style={{background:'red', color:'white', border:'none', borderRadius:'4px', cursor:'pointer', fontSize:'10px', marginTop:'5px'}}>حذف</button>
               </div>
             ))}
           </div>
        </div>
      )}

      {/* ⚠️ هنا كان الخطأ: تم إضافة حماية (reviews || []) */}
      {activeTab === 'reviews' && (
        <div className="fade-in">
           <form onSubmit={handleReviewSubmit} style={{ background: '#fff7ed', padding: '20px', borderRadius: '10px', marginBottom: '20px', display:'flex', gap:'10px' }}>
             <input placeholder="اسم العميل" required value={newReview.name} onChange={e=>setNewReview({...newReview, name:e.target.value})} style={inputClass} />
             <input placeholder="التعليق" required value={newReview.comment} onChange={e=>setNewReview({...newReview, comment:e.target.value})} style={inputClass} />
             <button type="submit" style={{...btnClass(true), background: '#f59e0b'}}>نشر</button>
           </form>
           {(reviews || []).map(r => (
             <div key={r.id} style={{padding:'10px', borderBottom:'1px solid #eee', display:'flex', justifyContent:'space-between'}}>
               <span><b>{r.name}</b>: {r.comment}</span>
               <button onClick={()=>onDeleteReview(r.id)} style={{color:'red', border:'none', background:'none', cursor:'pointer'}}>حذف</button>
             </div>
           ))}
        </div>
      )}

      {activeTab === 'settings' && (
        <div style={{textAlign:'center', padding:'40px'}}>
          <h3>🔐 تغيير كلمة المرور</h3>
          <input type="text" placeholder="اكتب كلمة السر الجديدة" value={passData.newPass} onChange={e=>setPassData({newPass:e.target.value})} style={{...inputClass, width:'200px', textAlign:'center'}} />
          <br/><br/>
          <button onClick={handlePassChange} style={btnClass(true)}>حفظ التغييرات</button>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;